import { defineMessages } from 'react-intl'

export default defineMessages({
  loadTemplateTableTitle: {
    id: 'loadTemplate.tableTitle',
    defaultMessage: 'Load Templates',
  },
  add: {
    id: 'loadTemplate.add',
    defaultMessage: 'Add Load Template',
  },
  clear: {
    id: 'loadTemplate.clear',
    defaultMessage: 'Clear',
  },
  clearSelection: {
    id: 'loadTemplate.clearSelection',
    defaultMessage: 'Clear Selection',
  },
  customerSelectable: {
    id: 'loadTemplate.customerSelectable',
    defaultMessage: 'Selectable by customers',
  },
  loadTemplateDeleted: {
    id: 'loadTemplate.deleted',
    defaultMessage: 'Load Template Deleted',
  },
  loadTemplateDeleteError: {
    id: 'loadTemplate.deleteError',
    defaultMessage: 'Error Deleting Load Template',
  },
  createEditLoadTemplate: {
    id: 'loadTemplate.createEdit',
    defaultMessage: 'Create/Edit Load Template',
  },
  viewLoadTemplate: {
    id: 'loadTemplate.view',
    defaultMessage: 'View Load Template',
  },
  name: {
    id: 'loadTemplate.name',
    defaultMessage: 'Name',
  },
  description: {
    id: 'loadTemplate.description',
    defaultMessage: 'Description',
  },
  isoCode: {
    id: 'loadTemplate.isoCode',
    defaultMessage: 'ISO Code',
  },
  loadType: {
    id: 'loadTemplate.loadType',
    defaultMessage: 'Load Type',
  },
  inUse: {
    id: 'loadTemplate.inUse',
    defaultMessage: 'In Use',
  },
  isSystemDefined: {
    id: 'loadTemplate.isSystemDefined',
    defaultMessage: 'System Defined',
  },
  newLoadTemplateBtn: {
    id: 'loadTemplate.newBtn',
    defaultMessage: 'Add',
  },
  editBtn: {
    id: 'loadTemplate.editBtn',
    defaultMessage: 'Edit',
  },
  cancelBtn: {
    id: 'loadTemplate.cancelBtn',
    defaultMessage: 'Cancel',
  },
  loadTemplateCreated: {
    id: 'loadTemplate.created',
    defaultMessage: 'Load Template Created',
  },
  loadTemplateUpdated: {
    id: 'loadTemplate.updated',
    defaultMessage: 'Load Template Updated',
  },
  loadTemplateNotUpdated: {
    id: 'loadTemplate.notUpdated',
    defaultMessage: 'Load Template Not Updated',
  },
  loadTemplateNotAdded: {
    id: 'loadTemplate.notAdded',
    defaultMessage: 'Load Template Not Added',
  },
  loadTemplateNotDeleted: {
    id: 'loadTemplate.notDeleted',
    defaultMessage: 'Load Template Not Deleted',
  },
  deleteLoadTemplateTitle: {
    id: 'loadTemplate.deleteLoadTemplateTitle',
    defaultMessage: 'Delete Load Template',
  },
  deleteLoadTemplateDescription: {
    id: 'loadTemplate.deleteLoadTemplateDescription',
    defaultMessage: 'Are you sure you want to delete this load template?',
  },
  deleteBtn: {
    id: 'loadTemplate.deleteBtn',
    defaultMessage: 'Delete',
  },
  // Physical Properties Messages
  physicalProperties: {
    id: 'loadTemplate.physicalProperties',
    defaultMessage: 'Physical Properties',
  },
  dimensions: {
    id: 'loadTemplate.dimensions',
    defaultMessage: 'Dimensions',
  },
  netWeight: {
    id: 'loadTemplate.netWeight',
    defaultMessage: 'Net Weight',
  },
  grossWeight: {
    id: 'loadTemplate.grossWeight',
    defaultMessage: 'Gross Weight',
  },
  chargeableWeight: {
    id: 'loadTemplate.chargeableWeight',
    defaultMessage: 'Chargeable Weight',
  },
  volume: {
    id: 'loadTemplate.volume',
    defaultMessage: 'Volume',
  },
  density: {
    id: 'loadTemplate.density',
    defaultMessage: 'Density',
  },
  height: {
    id: 'loadTemplate.height',
    defaultMessage: 'Height',
  },
  length: {
    id: 'loadTemplate.length',
    defaultMessage: 'Length',
  },
  width: {
    id: 'loadTemplate.width',
    defaultMessage: 'Width',
  },
  maxLoadingHeight: {
    id: 'loadTemplate.maxLoadingHeight',
    defaultMessage: 'Max Loading Height',
  },
  validFrom: {
    id: 'loadTemplate.validFrom',
    defaultMessage: 'Valid From',
  },
  validTo: {
    id: 'loadTemplate.validTo',
    defaultMessage: 'Valid To',
  },
  unit: {
    id: 'loadTemplate.unit',
    defaultMessage: 'Unit',
  },
})
